import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export function useLocalStorage(
  key: string,
): [string | null, Dispatch<SetStateAction<string | null>>] {
  const isBrowser = typeof window !== 'undefined';

  const [state, setState] = useState<string | null>(null);

  // Initialize state with the value from localStorage once the component mounts
  useEffect(() => {
    if (isBrowser) {
      setState(localStorage.getItem(key));
    }
  }, [key, isBrowser]);

  const setWithLocalStorage = (nextState: SetStateAction<string | null>) => {
    if (isBrowser) {
      if (typeof nextState === 'function') {
        setState((prev) => {
          const result =
            typeof nextState === 'function' ? nextState(prev) : nextState;
          if (result !== null) {
            localStorage.setItem(key, result);
          } else {
            localStorage.removeItem(key);
          }
          return result;
        });
      } else {
        if (nextState !== null) {
          localStorage.setItem(key, nextState);
        } else {
          localStorage.removeItem(key);
        }
        setState(nextState);
      }
    }
  };

  return [state, setWithLocalStorage];
}
